export default "__VITE_ASSET__0a0a6680__"